import TheForm from './TheForm';
import ResultTabs from './ResultTabs';

export { TheForm, ResultTabs };
